var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoNextcloudWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.059,
    height: 15.96,
    viewBox: "0 0 35.059 15.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_nextcloud_white_svg__logo_nextcloud_white",
    transform: "translate(-9.375 -9.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_nextcloud_white_svg__path1052",
    d: "M26.931,9.375a8.006,8.006,0,0,0-7.669,5.8,5.19,5.19,0,1,0,0,4.356,7.971,7.971,0,0,0,15.319.075,5.189,5.189,0,1,0,0-4.506A8.009,8.009,0,0,0,26.931,9.375Zm0,3.046A4.934,4.934,0,1,1,22,17.355a4.911,4.911,0,0,1,4.934-4.934ZM14.564,15.212a2.143,2.143,0,1,1-2.143,2.143,2.121,2.121,0,0,1,2.143-2.143Zm24.68,0A2.143,2.143,0,1,1,37.1,17.355,2.121,2.121,0,0,1,39.244,15.212Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNextcloudWhite);
export default __webpack_public_path__ + "static/media/logo_nextcloud_white.2eae91db7a7708057b7ba6f194ffdd63.svg";
export { ForwardRef as ReactComponent };